import { useState } from "react";
import { Box, Button, Grid, Modal, Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { TagValueCombo } from "components/survey/questions/SurveyQuestionDetails";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { getCodeText, userTypesMap } from "utils/shared/variables";
import ctaBackIconBlack from "assets/images/common/ctaBackIconBlack.svg";
import { useNavigate } from "react-router-dom";
import {
  deleteProgramAssignmentSurvey,
  fetchSurveyAssignments,
} from "redux/actions/survey/surveyAction";
import { useDispatch, useSelector } from "react-redux";

function SurveyAssignmentDetailsPage() {
  const dispatch = useDispatch();
  const params = useParams();
  const userOrganization = useSelector((e) => e.sidebar.organisation);
  const navigate = useNavigate();
  const location = useLocation();
  // Delete program
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };
  const { state } = location;
  const { surveyAssignmentDetails } = state || {};
  const confirmDeleteProgram = () => {
    dispatch(
      deleteProgramAssignmentSurvey({
        userOrganization,
        id: params?.surveyAssignmentId,
      })
    ).then((e) => {
      dispatch(
        fetchSurveyAssignments({
          page: 1,
          page_size: 10,
          userOrganization,
        })
      );
      handleDeleteModalClose();
      navigate("/programs/survey-assignment");
    });
  };
  return (
    <div>
      <Stack sx={{ marginBottom: "20px" }} direction="row" alignItems="center">
        <img
          className="animate__animated animate__fadeIn dt-ta-nav-page-info-tbtns-title1"
          src={ctaBackIconBlack}
          alt="add"
          onClick={() => navigate(-1)}
        />
        <p style={{ color: "#101828", fontSize: "18px", fontWeight: 600 }}>
          Survey Assignment Details
        </p>
      </Stack>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Program(s) assigned to"
            value={
              surveyAssignmentDetails?.program_assignment_details?.program
                ?.title
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Program sub heading"
            value={
              surveyAssignmentDetails?.program_assignment_details?.program
                ?.sub_title
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="User"
            value={
              surveyAssignmentDetails?.program_assignment_details?.user
                ? surveyAssignmentDetails?.program_assignment_details?.user
                    .first_name +
                  " " +
                  surveyAssignmentDetails?.program_assignment_details?.user
                    .last_name
                : "-"
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Role"
            // value={[...new Set(rolesAssignedByName)].join(", ")}
            value={getCodeText(
              "role",
              surveyAssignmentDetails?.program_assignment_details?.role ?? "-"
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Organization"
            // value={[...new Set(orgsAssignedByName)].join(", ")}
            value={
              surveyAssignmentDetails?.program_assignment_details?.organization
                ?.name ?? "-"
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Clinic"
            // value={[...new Set(orgsAssignedByName)].join(", ")}
            value={
              surveyAssignmentDetails?.program_assignment_details?.clinic
                ?.name ?? "-"
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Type"
            // value={[...new Set(orgsAssignedByName)].join(", ")}
            value={
              userTypesMap[
                surveyAssignmentDetails?.program_assignment_details?.user_type
              ] ?? "-"
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Group"
            // value={[...new Set(orgsAssignedByName)].join(", ")}
            value={
              surveyAssignmentDetails?.program_assignment_details?.group
                ?.title ?? "-"
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TagValueCombo
            styles={{
              borderBottom: "1.5px solid #DBDBDB",
              paddingBottom: "11px",
            }}
            label="Assigned on date"
            value={dayjs(surveyAssignmentDetails?.added_on).format(
              "MMM DD, YYYY"
            )}
          />
        </Grid>
      </Grid>

      {/* <Button
        onClick={handleDeleteModalOpen}
        sx={{ marginTop: "60px" }}
        variant="outlined">
        Delete
      </Button> */}
      <Modal
        open={isDeleteModalOpen}
        onClose={handleDeleteModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description">
        <Box className="dt-ta-prog-del-modal" sx={{ width: 400 }}>
          <div className="dt-ta-prog-del-modal-t1">
            Delete Survey Assignment
          </div>
          <div className="dt-ta-prog-del-modal-t2">
            Are you sure you want to delete this survey assignment?
          </div>
          <Stack
            className="dt-ta-prog-del-modal-btns"
            spacing={2}
            direction="row">
            <Button
              className="dt-ta-prog-del-modal-btns-out"
              variant="outlined"
              onClick={handleDeleteModalClose}>
              No
            </Button>
            <Button
              className="dt-ta-prog-del-modal-btns-filled"
              variant="contained"
              onClick={confirmDeleteProgram}>
              {/* {programDeleting ? (
                <div className="dot-flashing dot-flashing-t1 dt-ta-login-cta-ldr"></div>
              ) : (
                <span>Yes</span>
              )} */}
              <span>Yes</span>
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}

export default SurveyAssignmentDetailsPage;
